<script>
import { useTimeSlots } from 'Main/composables/useTimeSlots';
import {
  DEFAULT_ROLES,
  ORDER_TYPE_TO_REQUEST_TYPE_MAP,
  REQUEST_TYPES,
  USER_ROLE_TO_DEFAULT_ROLE_MAP,
} from 'Main/contact-form/constants.ts';
import { sprintf } from 'sprintf-js';
import { mapState } from 'vuex';

export default {

  computed: {

    competenceAreas() {
      if (!this.role) {
        return [];
      }

      const orderTypeDefinition = ORDER_TYPE_TO_REQUEST_TYPE_MAP[this.role]?.toUpperCase() || null;

      if (!orderTypeDefinition) {
        return [];
      }

      return this.counselor.competence_areas_list
        .filter(({ type }) => type === orderTypeDefinition)
        .map(({ name, slug }) => ({ name, slug }));
    },

    filteredCompetences() {
      const areas = Array.isArray(this.filteredCompetenceAreas)
        ? this.filteredCompetenceAreas
        : [];
      return areas
        .concat(this.filteredAccreditations || [])
        .concat(this.filteredTargetGroups || [])
        .concat(this.filteredTitles || [])
        .concat(this.filteredGender ? this.filteredGender : null)
        .concat(this.selectedCompetencesArray)
        .filter((item) => item !== null);
    },
    link() {
      const profile = this.counselor.profiles.find(
        ({ site_id: siteId }) =>
          parseInt(siteId) === parseInt(this.currentSiteId)
      );

      const linkToProfile = profile ? profile.url : '#';

      if (!this.role || linkToProfile === '#') {
        return linkToProfile;
      }

      const roleDefinition = USER_ROLE_TO_DEFAULT_ROLE_MAP[this.role] || null;

      return roleDefinition
        ? `${linkToProfile}?role=${roleDefinition}`
        : linkToProfile;
    },

    selectedCompetencesArray() {
      return this.selectedCompetences
        .split(',')
        .map((competence) => competence.trim())
        .filter((competence) => competence !== '');
    },

    ...mapState('counselorGrid', [
      'filteredCompetenceAreas',
      'filteredAccreditations',
      'filteredTargetGroups',
      'filteredLanguages',
      'filteredMeetingTypes',
      'filteredTitles',
      'filteredGender',
      'presetCompetence',
    ]),

    languagesString() {
      if (!this.filteredLanguages.length) {
        return '';
      }

      const lowercaseLanguages = this.counselor.languages
        .toLowerCase()
        .split(' ');

      const highlightedLanguages = lowercaseLanguages
        .map((language) => {
          return this.filteredLanguages
            .map((filteredLang) => filteredLang.toLowerCase())
            .includes(language)
            ? `<strong>${language}</strong>`
            : language;
        })
        .join(' ');

      return sprintf(this.texts.takesMeetingsIn, highlightedLanguages);
    },
  },

  data() {
    return {
      currentSite: theme_vars.currentSite,
      currentSiteId: theme_vars.currentSiteId,
      texts: theme_vars.counselorSlider,
    };
  },
  name: 'BaseCounselorCard',

  props: {
    cityLabel: {
      default: '',
      type: String,
    },
    counselor: {
      required: true,
      type: Object,
    },
    isTherapist: {
      default: false,
      type: Boolean,
    },
    role: {
      default: '',
      type: String,
    },
    schedule: {
      default: () => [],
      required: false,
      type: Array,
    },
    selectedCompetences: {
      default: '',
      type: String,
    },
    showCompetenceAreas: {
      default: false,
      type: Boolean,
    },
    showPhoneNumber: {
      default: false,
      type: Boolean,
    },
  },

  setup() {
    const {
      today,
      tomorrow,
      filterTimeSlots,
      generateMeetingTimes,
      formatReadableDate,
    } = useTimeSlots();
    return {
      filterTimeSlots,
      formatReadableDate,
      generateMeetingTimes,
      today,
      tomorrow,
    };
  },
};
</script>
